<script setup lang="ts">
const {t}=useI18n()
const globalConfig=computed<any>(()=>{
  return {
    imageViewer:{
      errorText:t('tDesign.imageViewer.failed'),
      mirrorTipText:t('tDesign.imageViewer.mirror'),
      originalSizeTipText:t('tDesign.imageViewer.original_size'),
      rotateTipText:t('tDesign.imageViewer.rotation')
    }
  }
})
</script>

<template>
  <t-config-provider :global-config="globalConfig">
    <router-view />
  </t-config-provider>

</template>

<style scoped></style>
